import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

export interface SetCredentialsCommandPayload {
  credentials: {
    sellerId: string;
    salesChannelId: string;
    credentials?: string;
  }[];
}

export const setCredentialsCommand = async (
  payload: SetCredentialsCommandPayload,
): Promise<BackResponseFailure | BaseBackResponse> => {
  try {
    return await apiCall<BaseBackResponse>(
      buildUrl(`${APIConfiguration.marketplace}credentials`),
      {
        method: SUPPORTED_METHODS.PUT,
        json: payload,
      },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
